import { combineReducers } from '@reduxjs/toolkit'
import SecureMessagesReducer from '../components/securemessages/store/SecureMessagesSlice'

const CommunicationCenterReducer = combineReducers({
  secureMessages: SecureMessagesReducer
})

export default CommunicationCenterReducer
